module.exports = __webpack_public_path__ + "static/media/popular3.6587b267.png";